import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Col, FormFeedback } from 'reactstrap';

import PhotoList from '../images/photo_list';

export default function AddImage(props) {
  const {
    classNameContainer,
    id,
    label,
    meta: { touched, error },
  } = props;

  let validationState = null;
  let errorText = null;

  if (touched) {
    if (error) {
      validationState = 'danger';
      errorText = error;
    } else {
      validationState = 'success';
    }
  }

  return (
    <FormGroup row color={validationState} className={`${classNameContainer} form-group-row`}>
      <Label for={id} className="form-group-row__label">
        {label}
      </Label>
      <Col className="form-group-row__col">
        <PhotoList id={id} {...props} />
        <FormFeedback>{errorText}</FormFeedback>
      </Col>
    </FormGroup>
  );
}

AddImage.propTypes = {
  input: PropTypes.shape({}),
  id: PropTypes.string,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  classNameContainer: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  children: PropTypes.node,
  photos: PropTypes.arrayOf(PropTypes.shape({})),
  meta: PropTypes.shape({}),
  previews: PropTypes.arrayOf(PropTypes.shape({})),
  loadingPhotos: PropTypes.arrayOf(PropTypes.shape({})),
  fieldRemovable: PropTypes.func,
  onDrop: PropTypes.func,
  onDelete: PropTypes.func,
};
